module.exports = __webpack_public_path__ + "static/media/facebook.d3f721f7.svg";